const Local = () => {
  return {
    environment: 'development',
    portal_url: 'https://portal2-891857883813.europe-west2.run.app',
    admin_portal_url: `https://portal2-891857883813.europe-west2.run.app/admin-portal`,
    customer_url: '',
    billing_url: '',
    metering_url: '',
    inventory_url: '',
    admin_url: '',
    orion_url: 'https://portal-orion-dot-trojan-tcs-csms-dev.nw.r.appspot.com',
    stripePublicKey:
      'pk_test_51QI5woEHscO39yl1YP5IOjiGOZTtYxNPQdLlfWgWphu2TQr37EXObU13VBh2oX29xWpS3p1kXyonFnxMzbzZqIoR00fQcf4Wv8'
  };
};

module.exports = {
  Local
};
